<ng-container *ngIf="!isMobile">

  <div class="flex flex-col relative py-4">
    <div class="mobile-full-width relative">
      <iho-skeleton *ngFor="let item of [0,1,2]" height="32px" width="100px" class="ml-2 overflow-hidden float-right" />
      <iho-skeleton height="32px" width="100px" class="float-left overflow-hidden" />

    </div>
  </div>
  <div class="flex">
    <div class="w-full grid gap-2 grid-cols-1 grid-rows-1">
      <div class="item-gallery w-full h-[400px] pl-2">
        <iho-skeleton height="100%" width="100%" class="rounded-full overflow-hidden" />
      </div>
    </div>
    <div class="h-[400px] w-full grid grid-cols-2 grid-rows-2 gap-2">
      <div class="item-gallery relative">
        <iho-skeleton height="100%" width="100%" class="rounded-full overflow-hidden" />
      </div>
      <div class="item-gallery relative">
        <iho-skeleton height="100%" width="100%" class="rounded-full overflow-hidden" />
      </div>
      <div class="item-gallery relative ">


        <iho-skeleton height="100%" width="100%" class="rounded-full overflow-hidden" />
      </div>
      <div class="item-gallery relative">
        <div
          class="absolute cursor-pointer text-white rounded-bl-lg bg-[rgba(0,0,0,0.3)] top-0 right-0 w-full h-full flex justify-center items-center flex-col">
          <i class="ico-Picture text-xl font-bold"></i>
          <span class="text-sm">تصاویر بیشتر</span>
        </div>

        <iho-skeleton height="100%" width="100%" class="rounded-full overflow-hidden" />
      </div>
    </div>
  </div>
  <div class=" flex items-start gap-6 mt-4">
    <div class="w-[71%]">
      <nav class="flex justify-center items-center lg:px-6 mobile-full-width h-11 bg-white shadow-sm overflow-hidden">
        <ul class="flex justify-between items-center h-full w-full relative">
          <iho-skeleton *ngFor="let item of [0,1,2,3,4]" height="30px" width="70px" class="overflow-hidden" />
        </ul>
      </nav>

      <div class="flex items-center justify-between w-full mt-5">
        <iho-skeleton height="50px" width="200px" class="overflow-hidden mb-3" />

        <div class="hidden md:flex items-center gap-4">
          <iho-skeleton *ngFor="let item of [0,1]" height="50px" width="50px" class="overflow-hidden mb-3" />
        </div>
      </div>
      <div class="flex items-center justify-between w-full mb-4">
        <iho-skeleton height="50px" width="100px" class="float-left overflow-hidden mb-3" />
        <iho-skeleton height="50px" width="200px" class="overflow-hidden mb-3" />

      </div>
      <div class="flex flex-col justify-stretch items-stretch w-full mt-4 float-right">
        <iho-skeleton height="50px" width="200px" class="overflow-hidden mb-3" />
      </div>

      <iho-pdp-ecolodge-host-skeleton />

      <div class="flex items-center justify-between w-full mb-4 pt-4 border-solid  border-top">
        <iho-skeleton *ngFor="let item of [0,1]" height="50px" width="200px" class="overflow-hidden mb-3" />
      </div>
      <div class="flex flex-col justify-stretch items-stretch w-full mt-4 float-right">
        <iho-skeleton height="50px" width="200px" class="overflow-hidden mb-3" />
      </div>


    </div>

    <aside class="w-[29%] border border-solid p-4 rounded-lg">
      <div class="flex flex-col justify-stretch items-stretch w-full mt-4">
        <iho-skeleton *ngFor="let item of [0,1]" height="50px" width="100%" class="overflow-hidden mb-3" />
      </div>
      <div class="flex  items-center justify-between w-full">
        <iho-skeleton height="50px" width="200px" class="rounded-lg ml-2 mb-4  overflow-hidden" />
        <iho-skeleton height="50px" width="200px" class="rounded-lg mb-4 overflow-hidden" />

      </div>
      <iho-skeleton height="50px" width="100%" class="overflow-hidden mb-3" />
    </aside>

  </div>

</ng-container>
<ng-container *ngIf="isMobile">
  <div class="mobile-full-width relative h-[100vh]">

    <iho-skeleton height="240px" width="100%" class="w-100 !m-[0px]" />
    <nav class=" w-full px-4 mt-3">
      <ul class="flex justify-center items-center h-full w-full relative gap-2">
        <iho-skeleton *ngFor="let item of [0,1,2,3,4]" height="20px" width="70px" class="overflow-hidden" />
      </ul>
    </nav>
    <div class="flex items-start justify-start flex-col w-full mt-7 pr-3 mx-4">
      <iho-skeleton height="32px" width="200px" class="overflow-hidden mb-3" />
      <iho-skeleton height="24px" width="100px" class="overflow-hidden mb-3" />
      <iho-skeleton height="24px" width="230px" class="overflow-hidden mb-3" />
      <iho-skeleton height="44px" width="44px" class="overflow-hidden my-7" />
      <iho-skeleton height="32px" width="250px" class="overflow-hidden my-3" />
      <div class="grid grid-cols-2 w-full gap-2">
        <iho-skeleton height="24px" width="100px" class="overflow-hidden mb-3" />
        <iho-skeleton height="24px" width="100px" class="overflow-hidden mb-3" />
        <iho-skeleton height="24px" width="100px" class="overflow-hidden mb-3" />
        <iho-skeleton height="24px" width="100px" class="overflow-hidden mb-3" />

      </div>
      <iho-skeleton height="32px" width="140px" class="overflow-hidden mt-2" />


    </div>
  </div>

</ng-container>
